import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { createLead } from "../lib/api";

export const ContactForm = ({ topic = "", defaultType = "beratung", compact = false, testid = "contact-form" }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [type, setType] = useState(defaultType);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return toast.error("Bitte Name und E-Mail angeben.");
    setLoading(true);
    try {
      await createLead({ ...form, type, topic, source: "page" });
      setDone(true);
      toast.success("Ihre Anfrage ist eingegangen!");
    } catch {
      toast.error("Etwas ist schiefgelaufen. Bitte erneut versuchen.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="text-center py-10" data-testid={`${testid}-success`}>
        <CheckCircle2 className="h-14 w-14 text-blue-600 mx-auto mb-4" />
        <h4 className="font-heading text-2xl text-navy-900 mb-2">Vielen Dank!</h4>
        <p className="text-slate-500">Wir melden uns persönlich innerhalb von 24 Stunden bei Ihnen.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-5" data-testid={testid}>
      {!compact && (
        <div className="flex flex-wrap gap-2 mb-2">
          {[
            { k: "beratung", l: "Beratung" },
            { k: "rueckruf", l: "Rückruf" },
            { k: "termin", l: "Termin" },
          ].map((o) => (
            <button
              key={o.k}
              type="button"
              onClick={() => setType(o.k)}
              className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                type === o.k ? "bg-blue-700 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
              data-testid={`${testid}-type-${o.k}`}
            >
              {o.l}
            </button>
          ))}
        </div>
      )}
      <input required placeholder="Name *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-transparent border-b-2 border-slate-200 focus:border-blue-500 outline-none py-3 text-sm transition-colors" data-testid={`${testid}-name`} />
      <input required type="email" placeholder="E-Mail *" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border-b-2 border-slate-200 focus:border-blue-500 outline-none py-3 text-sm transition-colors" data-testid={`${testid}-email`} />
      <input placeholder="Telefon / WhatsApp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-transparent border-b-2 border-slate-200 focus:border-blue-500 outline-none py-3 text-sm transition-colors" data-testid={`${testid}-phone`} />
      <textarea placeholder="Ihre Nachricht (optional)" rows={3} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-transparent border-b-2 border-slate-200 focus:border-blue-500 outline-none py-3 text-sm transition-colors resize-none" data-testid={`${testid}-message`} />
      <button type="submit" disabled={loading} className="w-full rounded-full bg-blue-700 hover:bg-blue-600 disabled:opacity-60 text-white py-4 font-medium transition-colors flex items-center justify-center gap-2" data-testid={`${testid}-submit`}>
        {loading ? <><Loader2 className="h-5 w-5 animate-spin" /> Wird gesendet…</> : "Jetzt anfragen"}
      </button>
      <p className="text-[11px] text-slate-400 text-center">Kostenlos & unverbindlich · DSGVO-konform</p>
    </form>
  );
};
